import React from 'react';
import b_ from 'b_';

import {SurveysGoal} from 'client/common/types';
import {sendGoal} from 'client/common/utils/metrika';
import {getStaffUrl, getStaffAvatarUrl} from 'client/common/utils/yandex-team';
import {useUser} from 'client/common/contexts/user';
import {User} from '@yandex-lego/user/desktop';
import {tld} from 'client/common/utils/tld';
import {isYandexTeamDomain} from 'client/common/utils/yandex-team';

const b = b_.with('header2');

export function UserPicBox() {
    const user = useUser();
    const login = user?.info?.login;

    if (login === undefined) {
        return null;
    }

    const lang = user?.lang ?? 'ru';

    const handleLogin = () => {
        sendGoal(SurveysGoal.ClickHeaderEnter);
    };

    return isYandexTeamDomain ? (
        <div className={b('UserPicBox')}>
            <a
                className={b('UserPicLink')}
                href={getStaffUrl(login)}
                target='_blank'
                rel='noopener noreferrer'
            >
                <img className={b('UserPic')} src={getStaffAvatarUrl(login)} />
            </a>
        </div>
    ) : (
        <div className={b('user')}>
            <User
                avatarId={user?.info?.avatar.default}
                tld={tld}
                lang={lang}
                fetchMail
                plus
                onClick={handleLogin}
            />
        </div>
    );
}
